import { error } from "console";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import {
  ValidationResponse,
  ExternalRegistration,
} from "../models/ExternalRegistration";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const validateQuestionaryUser = async (
  questionaryId: string
): Promise<ValidationResponse> => {
  const response = await fetch(
    `${API_BASE_URL}/ExternalRegistration/ValidateQuestionaryUser`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json; charset= utf-8" },
      body: JSON.stringify(questionaryId),
    }
  );

  const data = await response.json();
  return data;
};

const registerExternalUser = async (
  externalRegistration: ExternalRegistration
) => {
  const response = await fetch(
    `${API_BASE_URL}/ExternalRegistration/ExternalRegistration`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json; charset= utf-8" },
      body: JSON.stringify(externalRegistration),
    }
  );

  return response;
};

const ExternalRegistrationService = {
  validateQuestionaryUser,
  registerExternalUser,
};

export default ExternalRegistrationService;
